import React, { useEffect, useState } from 'react'
import LocateBed from "../../../assets/images/locate-bed.svg";
import FundHotel from "../../../assets/images/fund-hotel.svg";
import { Link } from 'react-router-dom';
import useMyAgencyData from '../../../hooks/useMyAgencyData';
import createAxiosInstance from "../../../utils/axiosInstance";
import { API_ENDPOINTS } from "../../../utils/api";
import Loader from '../../../Components/Loader';
import { useFeature } from '../../../hooks/useFeature';
import { User } from '../../../type/User';

type HomeProps = {
  userData: User | null;
  triggerPopup: () => void;
};

const Homepage: React.FC<HomeProps> = (({ userData, triggerPopup }) => {
  const myShelter = useMyAgencyData();
  const canReceiveRequest = useFeature("bedfinder:canReceiveRequest");
  const [request, setRequest] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const axiosInstance = createAxiosInstance();

  useEffect(() => {
    if (userData && userData.hasSeenNewUiPopup !== true) {
      triggerPopup();
    }
    if (myShelter) {
      setIsLoading(false);
      getRequestFromOthers();
    }
  }, [userData, myShelter]);

  const getRequestFromOthers = async () => {
    try {
      const response = await axiosInstance.get(`${API_ENDPOINTS.BEDFINDER.GETREQUESTFROMOTHERS}?status=open&expand=need/assessments,responses`);

      const data = response.data; // Extract the actual data

      const requests = data?.filter(
        (request: any) =>
          !request.responses?.find(
            (response: any) =>
              response.agencyId === myShelter?.agencyId &&
              response.response !== "null",
          ),
      ).reverse();

      // console.log(requests);
      setRequest(requests);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="container py-5 md:py-10 xl:py-[70px]">
        <div className="card flex flex-col justify-center items-center p-4 md:p-8 2xl:p-14 h-[80vh] lg:h-[60vh]">
          <div className="text-center w-7/12">
            <h4 className='text-dark font-semibold text-lg 2xl:text-3xl'>{myShelter?.details?.displayName}</h4>
          </div>
          <ul className='flex flex-col md:flex-row justify-center gap-4 md:space-x-10 mt-4 md:mt-10'>
            <li>
              <Link to={'/bedfinder'} className='border border-gray-300 p-4 2xl:p-6 rounded-2xl relative w-48 h-48 2xl:w-64 2xl:h-64 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-100 transition-all delay-100'>
                <div className="w-16 h-18"><img src={LocateBed} className='w-fit' alt="LocateBed" /></div>
                {canReceiveRequest &&
                  <span className="flex items-center justify-center w-7 h-7 absolute top-2 right-2 ms-2 text-sm font-semibold text-white bg-secondary rounded-2xl">
                    {request.length}
                  </span>
                }

                <h4 className='lg:text-sm 2xl:text-lg text-gray-600 mt-6 font-semibold uppercase text-center px-5'>Locate A Shelter Bed</h4>
              </Link>
            </li>
            <li>
              <Link to={'/safenight'} className='border border-gray-300 p-4 2xl:p-6 rounded-2xl w-48 h-48 2xl:w-64 2xl:h-64 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-100 transition-all delay-100'>
                <div className="w-16 h-16"><img src={FundHotel} className='w-fit ms-3' alt="FundHotel" /></div>
                <h4 className='lg:text-sm 2xl:text-lg text-gray-600 mt-6 font-semibold uppercase text-center px-5'>Fund A hotel Room</h4>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
});

export default Homepage;